import { useMemo } from "react";
import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

export const useCommunityBotProfileSearch = ({
  name = "",
  disabled = false,
} = {}) => {
  const fetchBotProfiles = () =>
    reactQueryGet(
      internalApi.communityInbox.botSearch({
        params: { name },
      }),
    );

  const isEnabled = !disabled;

  const { data, isLoading } = useQuery(
    ["community-inbox", "chat-bot", "profiles", name],
    fetchBotProfiles,
    {
      enabled: isEnabled,
      staleTime: name === "" ? 5 * 60 * 1000 : 0,
      cacheTime: 10 * 60 * 1000,
    },
  );

  const botProfiles = useMemo(() => data?.records || [], [data?.records]);

  return {
    botProfiles,
    isBotsLoading: isLoading,
  };
};
